import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

const ShoppingCartContainer = ({ children }) => {
  const [checkoutNavElement, setCheckoutNavElement] = useState(null);
  
  useEffect(() => {
    // Create an element if it doesn't exist
    let element = document.getElementById('checkout-nav');
    
    if (!element) {
      // If checkout-nav doesn't exist, try to find navbar
      const navbar = document.querySelector('.navbar-nav.ml-auto');
      
      if (navbar) {
        // Create a new element to hold the shopping cart
        element = document.createElement('li');
        element.id = 'checkout-nav';
        element.className = 'nav-item';
        
        // Insert it before the first child of the navbar
        if (navbar.firstChild) {
          navbar.insertBefore(element, navbar.firstChild);
        } else {
          navbar.appendChild(element);
        }
      } else {
        console.warn("Could not find navbar to insert checkout-nav");
        return;
      }
    }
    
    setCheckoutNavElement(element);
  }, []);
  
  // Only render if we found the target element
  if (!checkoutNavElement) {
    return null;
  }
  
  return ReactDOM.createPortal(
    children,
    checkoutNavElement
  );
};

export default ShoppingCartContainer;
